import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  SvgIcon,
} from '@material-ui/core';
import { Button } from '~/components/ra';
import { useTranslate, usePermissions } from 'react-admin';

import { selectors, clearApprovalRequired } from '~/ducks/approvalRequired';
import { ArrowForwardCircleIcon } from '~/img';

const ApprovalRequiredDialog: FC = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const t = (key: string) => translate(`components.ApprovalRequiredDialog.${key}`);

  const approvalCaseId = useSelector(selectors.getApprovalCaseId);

  const { permissions } = usePermissions();
  const hasPermissionApprovalCaseView =
    permissions?.includes('approvalCase.view') || permissions?.includes('approvalCase.admin');

  const handleClose = () => {
    dispatch(clearApprovalRequired());
  };

  const handleView = () => {
    // clearApprovalRequired must be dispatched alongside navigation — without it,
    // approvalCaseId remains in the store and the dialog reopens on the new page.
    dispatch(push(`/approvals/queue/${approvalCaseId}/show`));
    dispatch(clearApprovalRequired());
  };

  return (
    <Dialog open={!!approvalCaseId} onClose={handleClose} maxWidth='xs' fullWidth>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('message')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button label={t('close')} onClick={handleClose} />
        {hasPermissionApprovalCaseView && (
          <Button label={t('viewCase')} onClick={handleView} variant='contained'>
            <SvgIcon>
              <ArrowForwardCircleIcon />
            </SvgIcon>
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalRequiredDialog;
